export default "__VITE_ASSET__$JBShMoG__"